import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { type YatPageItem } from '@app/client/common/structs/yatPage/yat-page-items';
import { processPageItem } from '@app/helpers';

import { type RootState } from '../reducers';
import { isContentItemNft } from '../slices/yat-page/types';
import {
    ACTION_SET_MANAGER_SEARCH_VALUE,
    ACTION_UPDATE_MANAGER_NFT_FILTERS,
    type NFTItem,
    type NFTManagerFilter,
} from '../types/nft-manager';

export const setNFTManagerSearchValue = (managerSearchValue: string) => {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        dispatch({
            type: ACTION_SET_MANAGER_SEARCH_VALUE,
            managerSearchValue,
        });
    };
};

export const updateNFTManagerFilters = ({ filter, clear = false }: { filter?: NFTManagerFilter; clear?: boolean }) => {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        dispatch({
            type: ACTION_UPDATE_MANAGER_NFT_FILTERS,
            filter,
            clear,
        });
    };
};

export type QueryItemsType = (
    | { nft: boolean }
    | { metadata_complete?: boolean }
    | { collection_name?: string }
    | { nft_name?: string }
    | { floor_price_le: number }
    | { floor_price_ge: number }
    | { owner_address: string }
    | { owner_addresses: string[] }
    | { spam: boolean }
)[];

type QueryItemsProps = {
    searchValue?: string;
    operator: 'OR' | 'AND';
    currentFilters: NFTManagerFilter;
};
export const getQueryItems = ({ searchValue, operator, currentFilters }: QueryItemsProps) => {
    const queryItems: QueryItemsType = operator == 'OR' ? [] : [{ nft: true }, { metadata_complete: true }];

    // Adds current available filters
    if (searchValue) {
        queryItems.push({ collection_name: searchValue });
        queryItems.push({ nft_name: searchValue });
    } else {
        currentFilters.floorPriceLe && queryItems.push({ floor_price_le: currentFilters.floorPriceLe });
        currentFilters.floorPriceGe && queryItems.push({ floor_price_ge: currentFilters.floorPriceGe });
        currentFilters.ownerAddress?.length && queryItems.push({ owner_addresses: currentFilters.ownerAddress });
        queryItems.push({ spam: !!currentFilters.spam });
    }

    return queryItems;
};

export const serializeResponseItems = (items: YatPageItem[]): NFTItem[] =>
    items
        .map(processPageItem)
        .filter(isContentItemNft)
        .map((item) => ({
            ...item,
            hasPersisted: false,
        }));
